import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import {
    DKLabel,
    DKIcon,
    DKButton,
    DKInput,
    DKCheckMark,
    DKLine,
    showLoader,
    removeLoader,
    showToast,
    showAlert,
    TOAST_TYPE,
    INPUT_VIEW_DIRECTION
} from "deskera-ui-library";
import INComplianceService from "../../../../services/compliance/INComplianceService";
import RouteManager from "../../../../managers/RouteManager";
import { PAGE_ROUTES } from "../../../../managers/RouteManager";
import { TENANT, TenantService } from "../../../../managers/TenantManagerService";
import { DATE_FORMAT, FORMAT, INPUT_TYPE } from "../../../../constants/Constant";
import ic_check_mark from "../../../../assets/icons/check.svg";
import ic_close from "../../../../assets/icons/ic_close_3.svg";
import { Countries, IN_STATES } from "../../../../constants/CountryConstant";
import Utility, { deepClone } from "../../../../utility/Utility";
import { PAN_REGEX_PATTERN } from "../../../../constants/RegexConstants";
import moment from "moment";
import RejectInvestment from "./RejectInvestment"
import ReactTooltip from 'react-tooltip';
import ic_document from "../../../../assets/icons/ic_document.png";
import AttachmentService from "../../../../services/AttachmentService";
import { saveAs } from 'file-saver';
import { getQueryParam } from "../../../../managers/common/CommonUtil";
import { INVESTMENT_STAGE } from "./InvestmentConstants";
import AppManager from "../../../../managers/AppManager";
import FormatCurrencyService from "../../../../services/FormatCurrencyService";
import PermissionUtils, { ACTION, MODULE } from "../../../user-permissions/PermissionUtils";

function MyApproval(props) {
    const history = useHistory();

    const INVESTMENT_STATUS = {
        DRAFT: "DRAFT",
        SUBMITTED: "SUBMITTED",
        DECLARATION: "DECLARATION",
        PENDING: "PENDING",
        ACTUAL: "ACTUAL",
        REJECTED: "REJECTED",
        APPROVED: "APPROVED"
    };

    const employeeData = getQueryParam(props.location, "employeeData");
    const userId = props.userId || getQueryParam(props.location, "id");
    const employeeName = props.employeeName || getQueryParam(props.location, "name");
    const isMyApproval = TenantService.get(TENANT.USER_ID) === userId;

    const SECTION = {
        FINANCIAL_YEAR: "financialYear",
        REGIME: "regime",
        HOUSE_RENT: "houseRent",
        HOME_LOAN: "homeLoan",
        RENTAL_INCOME: "rentalIncome",
        INVESTMENT_80C: "investment80C",
        INVESTMENT_80D: "investment80D",
        OTHER_INVESTMENT: "otherInvestment",
        OTHER_INCOME: "otherIncome"
    };

    const METRO_CITIES = ["110", "400", "600", "700"];

    const width = "30%";
    const marginRight = "5%";

    const getFinancialYears = () => {
        const years = [];

        const todayYear = moment().year();
        const todayMonth = moment().month();

        let startYear = todayMonth > moment().month("March").month() ? todayYear : todayYear - 1;
        const endYear = todayMonth > moment().month("March").month() ? todayYear + 1 : todayYear;

        const dateOfCreation = TenantService.get(TENANT.DATE_OF_CREATION);
        if (dateOfCreation) {
            const dateOfCreationYear = moment(dateOfCreation, DATE_FORMAT.YYYYMMDD).year();
            if (dateOfCreationYear < startYear) {
                startYear = dateOfCreationYear;
            }
        }

        while(startYear !== endYear) {
            years.push(String().concat(startYear, " - ", startYear + 1));
            startYear++;
        }

        return years;
    }

    const getFinancialYearStartDate = () => {
        let startDate = null;

        const selectedFinancialYear = getSelectFieldValue(financialYear.financialYear, financialYears);
        if (selectedFinancialYear) {
            startDate = moment([selectedFinancialYear.split(" - ")[0], 3, 1]);
        }

        return startDate;
    }

    const financialYears = getFinancialYears();
    const defaultFinancialYear = [financialYears.length - 1];

    const states = IN_STATES.map(s => s.label);
    const countries = Countries.map(c => c.label);

    const getDefaultFieldConfig = (type, name, value, validation, options, readOnly, disabled, tooltip) => {
        return {
            type: type,
            name: name,
            value: value,
            validation: validation,
            invalid: false,
            errorMsg: null,
            options: options,
            readOnly: !!readOnly,
            disabled: !!disabled,
            tooltip: tooltip
        }
    }

    const getAttachmentConfig = () => {
        return {
            show: false,
            files: []
        }
    }

    const regimeOptions = [
        { name: "Old Tax Regime", value: false },
        { name: "New Tax Regime", value: true }
    ];

    const initialFinancialYearState = {
        financialYear: getDefaultFieldConfig(INPUT_TYPE.DROPDOWN, "Financial Year", defaultFinancialYear, [["required"]], financialYears)
    };

    const initialRegimeState = {
        newRegime: getDefaultFieldConfig("radio", "Regime", false, [[]], regimeOptions)
    };

    const initialHouseRentState = {
        rentalFromDate: getDefaultFieldConfig(INPUT_TYPE.DATE, "From", null, [["required"]]),
        rentalToDate: getDefaultFieldConfig(INPUT_TYPE.DATE, "To", null, [["required"]]),
        amount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Actual Amount", "0", [["required"]]),
        addressLine1: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Address Line 1", null, [["required"]]),
        addressLine2: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Address Line 2", null, [[]]),
        zipCode: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Zipcode", null, [["required"]]),
        city: getDefaultFieldConfig(INPUT_TYPE.TEXT, "City", null, [["required"]]),
        state: getDefaultFieldConfig(INPUT_TYPE.SELECT, "State", null, [["required"]], states),
        country: getDefaultFieldConfig(INPUT_TYPE.SELECT, "Country", [0], [["required"]], countries, true),
        landlordName: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Landlord Name", null, [["required"]]),
        landlordPAN: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Landlord PAN", null, [["pattern", PAN_REGEX_PATTERN]], null, false, false, "The PAN should follow the pattern SSSSS0000S where S-Alphabet, 0-Number"),
        isMetroCity: getDefaultFieldConfig(INPUT_TYPE.CHECKBOX, "Metro", false, [[]], null, true),
        approvedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "0", [["max"]]),
        comment: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", null, [[]]),
        status: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", INVESTMENT_STATUS.PENDING, [[]]),
        attachments: getAttachmentConfig()


    };

    const initialHomeLoanState = {
        homeLoanPrincipal: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Actual Principal Paid on Home Loan", "0", [["required"]]),
        homeLoanInterest: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Actual Interest Paid on Home Loan", "0", [["required"]]),
        lenderName: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Name of the Lender", null, [["required"]]),
        lenderPAN: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Lender PAN", null, [["required"], ["pattern", PAN_REGEX_PATTERN]]),
        approvedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "0", [["max"]]),
        comment: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", null, [[]]),
        status: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", INVESTMENT_STATUS.PENDING, [[]]),
        attachments: getAttachmentConfig(),
        approvedInterestAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "0", [["max"]]),
        interestStatus: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", INVESTMENT_STATUS.PENDING, [[]]),
        interestComment: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", null, [[]]),
        interestAttachments: getAttachmentConfig()

    };

    const initialRentalIncomeState = {
        annualRentReceived: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Actual Annual Rent Received", "0", [["required"]]),
        municipalTaxesPaid: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Actual Municipal Taxes Paid", "0", [["required"]]),
        netAnnualValue: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Actual Net Annual Value", null, [["required"]], null, true),
        standardDeduction: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Standard Deduction (@30% of Net Annual Value)", null, [["required"]], null, true),
        repayingHomeLoan: getDefaultFieldConfig(INPUT_TYPE.CHECKBOX, "Repaying Home Loan for this Property", true, [[]]),
        homeLoanPrincipal: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Principal Paid on Home Loan", "0", [["required"]]),
        homeLoanInterest: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Interest Paid on Home Loan", "0", [["required"]]),
        lenderName: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Name of the Lender", null, [["required"]]),
        lenderPAN: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Lender PAN", null, [["required"], ["pattern", PAN_REGEX_PATTERN]]),
        netIncomeLoss: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Net Income/Loss from House Property", "0", [["required"]], null, true),
        approvedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "0", [["max"]]),
        comment: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", null, [[]]),
        status: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", INVESTMENT_STATUS.PENDING, [[]]),
        attachments: getAttachmentConfig(),
        approvedMuncipalAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "0", [["max"]]),
        approvedPrincipalAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "0", [["max"]]),
        approvedInterestAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "0", [["max"]]),
        muncipalstatus: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", INVESTMENT_STATUS.PENDING, [[]]),
        princistatus: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", INVESTMENT_STATUS.PENDING, [[]]),
        intereststatus: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", INVESTMENT_STATUS.PENDING, [[]]),
        muncipalcomment: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", null, [[]]),
        princicomment: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", null, [[]]),
        interestcomment: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", null, [[]]),
        municipalTaxesAttachments: getAttachmentConfig(),
        principalAttachments: getAttachmentConfig(),
        interestAttachments: getAttachmentConfig()

    };

    const initialInvestmentState = {
        investment: getDefaultFieldConfig(INPUT_TYPE.SELECT, "Investment", null, [["required"]]),
        amount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Amount", "0", [["required"]]),
        approvedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "0", [["max"]]),
        comment: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", null, [[]]),
        status: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", INVESTMENT_STATUS.PENDING, [[]]),
        attachments: getAttachmentConfig()

    };

    const rejectInitial = {
        isReject: false,
        name: "",
        amount: "",
        index: "",
        attachments: []
    }

    let rejectFieldObj = {
        index: "",
        state: {},
        section: "",
        keyIndex: ""
    }

    const initialOtherIncomeSourceState = {
        amount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Income from other sources", "0", [["required"]]),
        attachments: getAttachmentConfig(),
        approvedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "0", [[]]),
        comment: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", null, [[]]),
        status: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", INVESTMENT_STATUS.PENDING, [[]]),
    };

    const initialSavingDepositInterestState = {
        amount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Interest Earned from Savings Deposit", "0", [[]]),
        attachments: getAttachmentConfig(),
        approvedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "0", [[]]),
        comment: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", null, [[]]),
        status: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", INVESTMENT_STATUS.PENDING, [[]]),
    };

    const initialFixedDepositInterestState = {
        amount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Interest Earned from Fixed Deposit", "0", [[]]),
        attachments: getAttachmentConfig(),
        approvedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "0", [[]]),
        comment: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", null, [[]]),
        status: getDefaultFieldConfig(INPUT_TYPE.TEXT, "", INVESTMENT_STATUS.PENDING, [[]]),
    };

    const [count, updateCount] = useState(1);

    const [financialYear, setFinancialYear] = useState(initialFinancialYearState);
    const [newRegime, setNewRegime] = useState(initialRegimeState);
    const [houseRentEnabled, setHouseRentEnabled] = useState(false);
    const [houseRentState, setHouseRentState] = useState([]);
    const [homeLoanEnabled, setHomeLoanEnabled] = useState(false);
    const [homeLoanState, setHomeLoanState] = useState([]);
    const [rentalIncomeEnabled, setRentalIncomeEnabled] = useState(false);
    const [rentalIncomeState, setRentalIncomeState] = useState([]);
    const [investment80CState, setInvestment80CState] = useState([]);
    const [investment80DState, setInvestment80DState] = useState([]);
    const [otherInvestmentState, setOtherInvestmentState] = useState([]);
    const [otherIncomeState, setOtherIncomeState] = useState([initialOtherIncomeSourceState, initialSavingDepositInterestState, initialFixedDepositInterestState]);

    const [taxDeclarationItems, setTaxDeclarationItems] = useState([]);
    const [investment80CItems, setInvestment80CItems] = useState([]);
    const [investment80DItems, setInvestment80DItems] = useState([]);
    const [otherInvestmentItems, setOtherInvestmentItems] = useState([]);

    const [isEdit, setIsEdit] = useState(false);
    const [ITDeclarationData, setITDeclarationData] = useState(null);
    const [isLocked, setIsLocked] = useState(null);
    const [rejected, setRejected] = useState(rejectInitial);
    const [approvedState, setApprovedState] = useState();
    const [rejectField, setrejectField] = useState({rejectFieldObj});

    const forceUpdate = () => {
        updateCount(count + 1);
    }

    useEffect(() => {
        RouteManager.setPresenter({props: {...props, history: history}});

        if (!userId) {
            RouteManager.navigateToHome();
            return;
        }

        AppManager.scrollToTop();
    }, []);

    useEffect(() => {
        if (financialYear) {
            getITDeclaration();
            resetData();
        }
    }, [financialYear]);

    useEffect(() => {
        if (taxDeclarationItems) {
            separateItemsIntoSections();
        }
    }, [taxDeclarationItems]);

    useEffect(() => {
        if (investment80CItems && investment80CItems.length > 0) {
            setInvestmentData(setInvestment80CState, ITDeclarationData.investment80C, investment80CItems, (approvedState && approvedState.investment80C ? approvedState.investment80C : {}));
        }
    }, [investment80CItems]);

    useEffect(() => {
        if (investment80DItems && investment80DItems.length > 0) {
            setInvestmentData(setInvestment80DState, ITDeclarationData.investment80D, investment80DItems, (approvedState && approvedState.investment80D ? approvedState.investment80D : {}));
        }
    }, [investment80DItems]);

    useEffect(() => {
        if (otherInvestmentItems && otherInvestmentItems.length > 0) {
            setInvestmentData(setOtherInvestmentState, ITDeclarationData.otherExemptions, otherInvestmentItems, (approvedState && approvedState.otherExemptions ? approvedState.otherExemptions : {}));
        }
    }, [otherInvestmentItems]);

    useEffect(() => {
        if (ITDeclarationData) {
            getTaxDeclarationItems();

            setNewRegime({ newRegime: { ...newRegime.newRegime, value: ITDeclarationData.newRegime } });
            setHouseRentData(ITDeclarationData.houseRents);
            setHomeLoanData(ITDeclarationData.homeLoanRepayment);
            setRentalIncomeData(ITDeclarationData.rentalIncome);
            setOtherIncomeData(ITDeclarationData.otherIncomeSources);
        }
    }, [ITDeclarationData]);

    useEffect(() => {
        forceUpdate();
    }, [
        houseRentState,
        homeLoanState,
        rentalIncomeState,
        investment80CState,
        investment80DState,
        otherInvestmentState,
        otherIncomeState
    ]);

    const getTaxDeclarationItems = () => {
        INComplianceService.getTaxDeclarationItems().then(
            (response) => {
                if (response) {
                    setTaxDeclarationItems(response);
                }
            }
        );
    }

    const setIsLockedState = (isLocked) => {
        if (!isMyApproval && !PermissionUtils.hasAccess(MODULE.EMPLOYEE_APPROVAL, [ACTION.DRAFT, ACTION.SUBMIT])) {
            isLocked = true;
        }

        setIsLocked(isLocked);
    }

    const resetData = () => {
        setIsEdit(false);
        setIsLockedState(false);
        setITDeclarationData(null);

        setNewRegime(initialRegimeState);
        setHouseRentEnabled(false);
        setHouseRentState([]);
        setHomeLoanEnabled(false);
        setHomeLoanState([]);
        setRentalIncomeEnabled(false);
        setRentalIncomeState([]);
        setInvestment80CState([]);
        setInvestment80DState([]);
        setOtherInvestmentState([]);
        setOtherIncomeState([initialOtherIncomeSourceState, initialSavingDepositInterestState, initialFixedDepositInterestState]);
    }

    const getITDeclaration = () => {
        showLoader();
        const params = {
            stage: INVESTMENT_STATUS.ACTUAL,
            financialYearStartDate: moment(getFinancialYearStartDate()).format(DATE_FORMAT.YYYYMMDD),
            userId: userId
        };

        INComplianceService.getITDeclaration(params).then(
            (response) => {
                if (response) {
                    if (response.status !== INVESTMENT_STATUS.SUBMITTED) {
                        showAlert("Alert", "Please submit POI first");
                        setIsLockedState(true);

                    } else {
                        setIsLockedState(false);
                    }
                }

                params.stage = INVESTMENT_STATUS.APPROVED
                INComplianceService.getITDeclaration(params).then(
                    (approvedResponse) => {

                        if (response) {
                            setApprovedState(approvedResponse);
                            setITDeclarationData(response);

                        }
                        setIsEdit(true);

                        removeLoader();
                    }, (error) => {
                        setITDeclarationData(response);
                        removeLoader();
                    }
                );

                removeLoader();
            }, (error) => {
                setIsLockedState(true);
                showAlert("Alert", "Please submit POI first");

                removeLoader();
            }
        );
    }

    const separateItemsIntoSections = () => {
        const investment80C = [];
        const investment80D = [];
        const otherInvestment = [];

        taxDeclarationItems.forEach((item) => {
            switch (item.section) {
                case "80C":
                case "80CC":
                case "80CCD(1)":
                    investment80C.push(item.value);
                    break;
                case "80D":
                    investment80D.push(item.value);
                    break;
                default:
                    if (["OTHER_INCOME", "HOME_LOAN", "HOUSE_RENT", "RENTAL_INCOME"].indexOf(item.section) === -1) {
                        otherInvestment.push(item.value);
                    }
            }
        });

        setInvestment80CItems(investment80C);
        setInvestment80DItems(investment80D);
        setOtherInvestmentItems(otherInvestment);
    }

    const setSelectFieldValue = (config, options, searchField, valueField) => {
        let index;
        if (valueField) {
            if (searchField) {
                index = options.findIndex((item) => item[searchField] === valueField);
            } else {
                index = options.findIndex((item) => item === valueField);
            }

            config.value = [[index]];
        }
    }

    const setAmountValue = (config, amountDetails, taxItemKey) => {
        if (amountDetails && amountDetails.length > 0) {
            const index = amountDetails.findIndex((amountDetail) => amountDetail.name === taxItemKey);
            if (index !== -1) {
                config.value = amountDetails[index].declaredAmount;
                config.readOnly = isLocked;
            }
        }
    }

    const setAttachments = (config, amountDetails) => {
        if (amountDetails && amountDetails.length > 0) {
            config.files = amountDetails[0].attachments ? amountDetails[0].attachments : [];
        }
    }

    const setHouseRentData = (houseRent) => {
        if (houseRent && houseRent.length > 0) {
            setHouseRentEnabled(true);

            const houseRentState = houseRent.map((rent, index) => {
                let state = deepClone(initialHouseRentState);
                state.rentalFromDate.value = rent.rentalFromDate;
                state.rentalToDate.value = rent.rentalToDate;
                setAmountValue(state.amount, rent.amountDetails, "HOUSE_RENT");
                state.addressLine1.value = rent.address.addressLine1;
                state.addressLine2.value = rent.address.addressLine2;
                state.zipCode.value = rent.address.zipCode;
                state.city.value = rent.address.city;
                setSelectFieldValue(state.state, IN_STATES, "value", rent.address.state);
                setSelectFieldValue(state.country, Countries, "value", rent.address.country);
                state.landlordName.value = rent.landlordName;
                state.landlordPAN.value = rent.landlordPAN;
                state.isMetroCity.value = rent.isMetroCity;
                if (approvedState && approvedState.houseRents && approvedState.houseRents[index]) {
                    state.approvedAmount.value = approvedState.houseRents[index].amountDetails[0].declaredAmount
                    state.comment.value = approvedState.houseRents[index].amountDetails[0].approverComments ? approvedState.houseRents[index].amountDetails[0].approverComments : []
                    state.status.value = approvedState.houseRents[index].amountDetails[0].status

                    if (state.status.value === INVESTMENT_STATUS.PENDING) {
                        setAmountValue(state.approvedAmount, rent.amountDetails, "HOUSE_RENT");
                    }
                } else {
                    setAmountValue(state.approvedAmount, rent.amountDetails, "HOUSE_RENT");
                }
                setAttachments(state.attachments, rent.amountDetails);


                return state;
            });

            setHouseRentState(houseRentState);
        }
    }

    const setHomeLoanData = (homeLoan) => {
        if (homeLoan && homeLoan.length > 0) {
            setHomeLoanEnabled(true);

            const homeLoanState = homeLoan.map((loan, index) => {
                const state = deepClone(initialHomeLoanState);
                setAmountValue(state.homeLoanPrincipal, loan.amountDetails, "HOME_LOAN_PRINCIPLE");
                setAmountValue(state.homeLoanInterest, loan.amountDetails, "HOME_LOAN_INTEREST");
                state.lenderName.value = loan.lenderName;
                state.lenderPAN.value = loan.lenderPAN;
                if (loan.amountDetails[0]) {
                    state.attachments.files = loan.amountDetails[0].attachments ? loan.amountDetails[0].attachments : [];
                    if (approvedState && approvedState.homeLoanRepayment) {
                        state.approvedAmount.value = approvedState.homeLoanRepayment[index].amountDetails[0].declaredAmount
                        state.status.value = approvedState.homeLoanRepayment[index].amountDetails[0].status
                        state.comment.value = approvedState.homeLoanRepayment[index].amountDetails[0].approverComments ? approvedState.homeLoanRepayment[index].amountDetails[0].approverComments : []

                        if (state.status.value === INVESTMENT_STATUS.PENDING) {
                            setAmountValue(state.approvedAmount, loan.amountDetails, "HOME_LOAN_PRINCIPLE");
                        }
                    } else {
                        setAmountValue(state.approvedAmount, loan.amountDetails, "HOME_LOAN_PRINCIPLE");
                    }
                }

                if (loan.amountDetails[1]) {
                    state.interestAttachments.files = loan.amountDetails[1].attachments ? loan.amountDetails[1].attachments : [];
                    if (approvedState && approvedState.homeLoanRepayment) {
                        state.approvedInterestAmount.value = approvedState.homeLoanRepayment[index].amountDetails[1].declaredAmount
                        state.interestStatus.value = approvedState.homeLoanRepayment[index].amountDetails[1].status
                        state.interestComment.value = approvedState.homeLoanRepayment[index].amountDetails[1].approverComments ? approvedState.homeLoanRepayment[index].amountDetails[1].approverComments : []

                        if (state.interestStatus.value === INVESTMENT_STATUS.PENDING) {
                            setAmountValue(state.approvedInterestAmount, loan.amountDetails, "HOME_LOAN_INTEREST");
                        }
                    } else {
                        setAmountValue(state.approvedInterestAmount, loan.amountDetails, "HOME_LOAN_INTEREST");
                    }
                }

                return state;
            });

            setHomeLoanState(homeLoanState);
        }
    }

    const setRentalIncomeData = (rentalIncome) => {
        if (rentalIncome && rentalIncome.length > 0) {
            setRentalIncomeEnabled(true);

            const rentalIncomeState = rentalIncome.map((rental, index) => {
                const state = deepClone(initialRentalIncomeState);
                setAmountValue(state.annualRentReceived, rental.amountDetails, "ANNUAL_RENT");
                setAmountValue(state.municipalTaxesPaid, rental.amountDetails, "MUNICIPAL_TAXES");
                state.netAnnualValue.value = parseAmount(state.annualRentReceived.value) - parseAmount(state.municipalTaxesPaid.value);
                state.standardDeduction.value = parseAmount(state.netAnnualValue.value) * 0.3;
                state.repayingHomeLoan.value = rental.repayingHomeLoanForThisProperty;

                if (rental.repayingHomeLoanForThisProperty) {
                    setAmountValue(state.homeLoanPrincipal, rental.amountDetails, "PRINCIPLE_PAID_HOME_LOAN");
                    setAmountValue(state.homeLoanInterest, rental.amountDetails, "INTEREST_PAID_HOME_LOAN");
                    state.lenderName.value = rental.lenderName;
                    state.lenderPAN.value = rental.lenderPAN;
                    state.netIncomeLoss.value = parseAmount(state.netAnnualValue.value) - parseAmount(state.standardDeduction.value) - parseAmount(state.homeLoanInterest.value);
                } else {
                    clearValidation(state, ["homeLoanPrincipal", "homeLoanInterest", "lenderName", "lenderPAN", "netIncomeLoss"]);
                }

                if (rental.amountDetails[0]) {
                    state.attachments.files = rental.amountDetails[0].attachments ? rental.amountDetails[0].attachments : [];
                    if (approvedState && approvedState.rentalIncome) {
                        state.approvedAmount.value = approvedState.rentalIncome[index].amountDetails[0].declaredAmount
                        state.status.value = approvedState.rentalIncome[index].amountDetails[0].status
                        state.comment.value = approvedState.rentalIncome[index].amountDetails[0].approverComments ? approvedState.rentalIncome[index].amountDetails[0].approverComments : []

                        if (state.status.value === INVESTMENT_STATUS.PENDING) {
                            setAmountValue(state.approvedAmount, rental.amountDetails, "ANNUAL_RENT");
                        }
                    } else {
                        setAmountValue(state.approvedAmount, rental.amountDetails, "ANNUAL_RENT");
                    }
                }
                if (rental.amountDetails[1]) {
                    state.municipalTaxesAttachments.files = rental.amountDetails[1].attachments ? rental.amountDetails[1].attachments : [];
                    if (approvedState && approvedState.rentalIncome) {
                        state.approvedMuncipalAmount.value = approvedState.rentalIncome[index].amountDetails[1].declaredAmount
                        state.muncipalstatus.value = approvedState.rentalIncome[index].amountDetails[1].status
                        state.muncipalcomment.value = approvedState.rentalIncome[index].amountDetails[1].approverComments ? approvedState.rentalIncome[index].amountDetails[1].approverComments : []

                        if (state.muncipalstatus.value === INVESTMENT_STATUS.PENDING) {
                            setAmountValue(state.approvedMuncipalAmount, rental.amountDetails, "MUNICIPAL_TAXES");
                        }
                    } else {
                        setAmountValue(state.approvedMuncipalAmount, rental.amountDetails, "MUNICIPAL_TAXES");
                    }
                }
                if (rental.amountDetails[2]) {
                    state.principalAttachments.files = rental.amountDetails[2].attachments ? rental.amountDetails[2].attachments : [];
                    if (approvedState && approvedState.rentalIncome) {
                        state.approvedPrincipalAmount.value = approvedState.rentalIncome[index].amountDetails[2].declaredAmount
                        state.princistatus.value = approvedState.rentalIncome[index].amountDetails[2].status
                        state.princicomment.value = approvedState.rentalIncome[index].amountDetails[2].approverComments ? approvedState.rentalIncome[index].amountDetails[2].approverComments : []

                        if (state.princistatus.value === INVESTMENT_STATUS.PENDING) {
                            setAmountValue(state.approvedPrincipalAmount, rental.amountDetails, "PRINCIPLE_PAID_HOME_LOAN");
                        }
                    } else {
                        setAmountValue(state.approvedPrincipalAmount, rental.amountDetails, "PRINCIPLE_PAID_HOME_LOAN");
                    }
                }
                if (rental.amountDetails[3]) {
                    state.interestAttachments.files = rental.amountDetails[3].attachments ? rental.amountDetails[3].attachments : [];
                    if (approvedState && approvedState.rentalIncome) {
                        state.approvedInterestAmount.value = approvedState.rentalIncome[index].amountDetails[3].declaredAmount
                        state.intereststatus.value = approvedState.rentalIncome[index].amountDetails[3].status
                        state.interestcomment.value = approvedState.rentalIncome[index].amountDetails[3].approverComments ? approvedState.rentalIncome[index].amountDetails[3].approverComments : []

                        if (state.intereststatus.value === INVESTMENT_STATUS.PENDING) {
                            setAmountValue(state.approvedInterestAmount, rental.amountDetails, "INTEREST_PAID_HOME_LOAN");
                        }
                    } else {
                        setAmountValue(state.approvedInterestAmount, rental.amountDetails, "INTEREST_PAID_HOME_LOAN");
                    }
                }
                return state;
            });

            setRentalIncomeState(rentalIncomeState);
        }
    }

    const setInvestmentData = (setState, investments, investmentItems, approved) => {
        if (investments && investments.amountDetails && investments.amountDetails.length > 0) {
            const investmentState = investments.amountDetails.map((investment, i) => {
                const state = deepClone(initialInvestmentState);
                const index = taxDeclarationItems.findIndex((item) => item.key === investment.name);
                if (index !== -1) {
                    setSelectFieldValue(state.investment, investmentItems, null, taxDeclarationItems[index].value);
                    setAmountValue(state.amount, investments.amountDetails, investment.name);
                    if (investments.amountDetails[i]) {
                        state.attachments.files = investments.amountDetails[i].attachments ? investments.amountDetails[i].attachments : [];
                    }
                }
                if (approved && approved.amountDetails && approved.amountDetails[i]) {
                    state.approvedAmount.value = approved.amountDetails[i].declaredAmount
                    state.status.value = approved.amountDetails[i].status
                    state.comment.value = approved.amountDetails[i].approverComments ? approved.amountDetails[i].approverComments : []

                    if (state.status.value === INVESTMENT_STATUS.PENDING) {
                        setAmountValue(state.approvedAmount, investments.amountDetails, investment.name);
                    }
                } else {
                    setAmountValue(state.approvedAmount, investments.amountDetails, investment.name);
                }
                return state;
            });

            setState(investmentState);
        }
    }

    const setOtherIncomeData = (otherIncome) => {
        if (otherIncome && otherIncome.amountDetails && otherIncome.amountDetails.length > 0) {
            const state = deepClone(otherIncomeState);

            setAmountValue(state[0].amount, otherIncome.amountDetails, "INCOME_OTHER_SOURCES");
            setAttachments(state[0].attachments, otherIncome.amountDetails);
            if (otherIncome.amountDetails[0]) {
                state[0].attachments.files = otherIncome.amountDetails[0].attachments ? otherIncome.amountDetails[0].attachments : [];
            }
            if (approvedState && approvedState.otherIncomeSources) {
                setAmountValue(state[0].approvedAmount, approvedState.otherIncomeSources.amountDetails, "INCOME_OTHER_SOURCES");
                state[0].status.value = approvedState.otherIncomeSources.amountDetails[0].status
                state[0].comment.value = approvedState.otherIncomeSources.amountDetails[0].approverComments ? approvedState.otherIncomeSources.amountDetails[0].approverComments : []

                if (state[0].status.value === INVESTMENT_STATUS.PENDING) {
                    setAmountValue(state[0].approvedAmount, otherIncome.amountDetails, "INCOME_OTHER_SOURCES");
                }
            } else {
                setAmountValue(state[0].approvedAmount, otherIncome.amountDetails, "INCOME_OTHER_SOURCES");
            }


            setAmountValue(state[1].amount, otherIncome.amountDetails, "SAVINGS_DEPOSIT_INTEREST");
            if (otherIncome.amountDetails[1]) {
                state[1].attachments.files = otherIncome.amountDetails[1].attachments ? otherIncome.amountDetails[1].attachments : [];
            }
            if (approvedState && approvedState.otherIncomeSources) {
                setAmountValue(state[1].approvedAmount, approvedState.otherIncomeSources.amountDetails, "SAVINGS_DEPOSIT_INTEREST");
                state[1].status.value = approvedState.otherIncomeSources.amountDetails[1].status
                state[1].comment.value = approvedState.otherIncomeSources.amountDetails[1].approverComments ? approvedState.otherIncomeSources.amountDetails[1].approverComments : []

                if (state[1].status.value === INVESTMENT_STATUS.PENDING) {
                    setAmountValue(state[1].approvedAmount, otherIncome.amountDetails, "SAVINGS_DEPOSIT_INTEREST");
                }
            } else {
                setAmountValue(state[1].approvedAmount, otherIncome.amountDetails, "SAVINGS_DEPOSIT_INTEREST");
            }


            setAmountValue(state[2].amount, otherIncome.amountDetails, "FIXED_DEPOSIT_INTEREST");
            if (otherIncome.amountDetails[2]) {
                state[2].attachments.files = otherIncome.amountDetails[2].attachments ? otherIncome.amountDetails[2].attachments : [];
            }
            if (approvedState && approvedState.otherIncomeSources) {
                setAmountValue(state[2].approvedAmount, approvedState.otherIncomeSources.amountDetails, "FIXED_DEPOSIT_INTEREST");
                state[2].status.value = approvedState.otherIncomeSources.amountDetails[2].status
                state[2].comment.value = approvedState.otherIncomeSources.amountDetails[2].approverComments ? approvedState.otherIncomeSources.amountDetails[2].approverComments : []

                if (state[2].status.value === INVESTMENT_STATUS.PENDING) {
                    setAmountValue(state[2].approvedAmount, otherIncome.amountDetails, "FIXED_DEPOSIT_INTEREST");
                }
            } else {
                setAmountValue(state[2].approvedAmount, otherIncome.amountDetails, "FIXED_DEPOSIT_INTEREST");
            }

            setOtherIncomeState(state);
        }
    }


    const getSelectFieldValue = (config, options, searchField, valueField) => {
        let actualValue;
        if (searchField && valueField) {
            actualValue = options.find((item) => item[searchField] === config.options[config.value[0]])[valueField];
        } else {
            actualValue = options.find((item) => item === config.options[config.value[0]]);
        }

        return actualValue;
    }

    const getAmountDetails = (amount, attachments, status, comment) => {
        const amountDetails = [];
        for (const [key, value] of Object.entries(amount)) {
            amountDetails.push({
                name: key,
                declaredAmount: parseAmount(value),
                actualAmount: 0,
                approvedAmount: 0,
                attachments: attachments ? attachments : [],
                status: status,
                approverComments: comment ? comment : []
            });
        }

        return amountDetails;
    }

    const getAmountDetailsObj = (key, value, attachments, status, comment) => {
        const amountDetails = {
            name: key,
            declaredAmount: parseAmount(value),
            actualAmount: 0,
            approvedAmount: 0,
            attachments: attachments ? attachments : [],
            status: status,
            approverComments: comment ? comment : []
        };


        return amountDetails;
    }

    const getHouseRentData = (houseRent) => {
        const houseRentData = [];

        houseRent.forEach((state) => {
            houseRentData.push({
                rentalFromDate: moment(state.rentalFromDate.value).format(DATE_FORMAT.YYYYMMDD),
                rentalToDate: moment(state.rentalToDate.value).format(DATE_FORMAT.YYYYMMDD),
                address: {
                    addressLine1: state.addressLine1.value,
                    addressLine2: state.addressLine2.value,
                    zipCode: state.zipCode.value,
                    city: state.city.value,
                    state: getSelectFieldValue(state.state, IN_STATES, "label", "value"),
                    country: getSelectFieldValue(state.country, Countries, "label", "value")
                },
                landlordName: state.landlordName.value,
                landlordPAN: state.landlordPAN.value,
                isMetroCity: state.isMetroCity.value,
                amountDetails: getAmountDetails({
                    "HOUSE_RENT": state.approvedAmount.value
                }, state.attachments.files, state.status.value, state.comment.value)
            });
        });

        return houseRentData;
    }

    const getHomeLoanData = (homeLoan) => {
        const homeLoanData = [];
        homeLoan.forEach((state, i) => {

            homeLoanData.push({
                lenderName: state.lenderName.value,
                lenderPAN: state.lenderPAN.value,
                amountDetails: [getAmountDetailsObj("HOME_LOAN_PRINCIPLE", state.approvedAmount.value, ITDeclarationData.homeLoanRepayment[i].amountDetails[0].attachments, state.status.value, state.comment.value), getAmountDetailsObj("HOME_LOAN_INTEREST",
                    state.approvedInterestAmount.value, ITDeclarationData.homeLoanRepayment[i].amountDetails[1].attachments, state.interestStatus.value, state.interestComment.value)]
            });
        });

        return homeLoanData;
    }

    const getRentalIncomeData = (rentalIncome) => {
        const rentalIncomeData = [];

        rentalIncome.forEach((state, index) => {
            const income = {
                netValue: state.netAnnualValue.value,
                deduction: state.standardDeduction.value,
                repayingHomeLoanForThisProperty: state.repayingHomeLoan.value
            }

            let anualRent = getAmountDetailsObj("ANNUAL_RENT", state.approvedAmount.value, ITDeclarationData.rentalIncome[index].amountDetails[0].attachments, state.status.value, state.comment.value)
            let muncipalTaxes = getAmountDetailsObj("MUNICIPAL_TAXES", state.approvedMuncipalAmount.value, ITDeclarationData.rentalIncome[index].amountDetails[1].attachments, state.muncipalstatus.value, state.muncipalcomment.value)
            if (state.repayingHomeLoan.value) {
                let principleHomeLoan = getAmountDetailsObj("PRINCIPLE_PAID_HOME_LOAN", state.approvedPrincipalAmount.value, ITDeclarationData.rentalIncome[index].amountDetails[2].attachments, state.princistatus.value, state.princicomment.value)
                let interest = getAmountDetailsObj("INTEREST_PAID_HOME_LOAN", state.approvedInterestAmount.value, ITDeclarationData.rentalIncome[index].amountDetails[3].attachments, state.intereststatus.value, state.interestcomment.value)

                income["lenderName"] = state.lenderName.value;
                income["lenderPAN"] = state.lenderPAN.value;
                income["netProfitLoss"] = state.netIncomeLoss.value;
                income["amountDetails"] = [anualRent, muncipalTaxes, principleHomeLoan, interest]
            } else {
                income["amountDetails"] = [anualRent, muncipalTaxes]
            }

            rentalIncomeData.push(income);
        });

        return rentalIncomeData;
    }

    const getInvestmentData = (investments) => {
        const amountDetails = [];

        investments.forEach((state) => {
            if (state.investment.value && state.investment.value.length > 0) {
                const key = getSelectFieldValue(state.investment, taxDeclarationItems, "value", "key");
                const amount = {
                    [key]: state.approvedAmount.value
                }
                amountDetails.push(...getAmountDetails(amount, state.attachments.files, state.status.value, state.comment.value))
            }
        });

        return {
            amountDetails: amountDetails
        }
    }

    const getPayload = () => {
        const payload = {
            userId: userId,
            financialYear: getSelectFieldValue(financialYear.financialYear, financialYears),
            newRegime: newRegime.newRegime.value,
            isHouseRentDetails: houseRentEnabled,
            isHouseRentalRepay: homeLoanEnabled,
            isHouseRentalIncome: rentalIncomeEnabled
        }

        if (houseRentEnabled) {
            payload["houseRents"] = getHouseRentData(houseRentState);
        }

        if (homeLoanEnabled) {
            payload["homeLoanRepayment"] = getHomeLoanData(homeLoanState);
        }

        if (rentalIncomeEnabled) {
            payload["rentalIncome"] = getRentalIncomeData(rentalIncomeState);
        }

        payload["investment80C"] = getInvestmentData(investment80CState);
        payload["investment80D"] = getInvestmentData(investment80DState);
        payload["otherExemptions"] = getInvestmentData(otherInvestmentState);

        payload["otherIncomeSources"] = {
            amountDetails: [
                ...getAmountDetails({ "INCOME_OTHER_SOURCES": otherIncomeState[0].approvedAmount.value }, otherIncomeState[0].attachments.files, otherIncomeState[0].status.value, otherIncomeState[0].comment.value),
                ...getAmountDetails({ "SAVINGS_DEPOSIT_INTEREST": otherIncomeState[1].approvedAmount.value }, otherIncomeState[1].attachments.files, otherIncomeState[1].status.value, otherIncomeState[1].comment.value),
                ...getAmountDetails({ "FIXED_DEPOSIT_INTEREST": otherIncomeState[2].approvedAmount.value }, otherIncomeState[2].attachments.files, otherIncomeState[2].status.value, otherIncomeState[2].comment.value)
            ]
        };

        return payload;
    }

    const isInvalidITDeclaration = () => {
        let invalid = false;
        const states = [financialYear, newRegime, investment80CState, investment80DState, otherInvestmentState];

        if (houseRentEnabled) {
            states.push(houseRentState);
        }

        if (homeLoanEnabled) {
            states.push(homeLoanState);
        }

        if (rentalIncomeEnabled) {
            states.push(rentalIncomeState);
        }

        states.forEach((state) => {
            if (isInvalidState(state)) {
                invalid = true;
            }
        });

        return invalid;
    }

    const showConfirmDialog = () => {
        showAlert(
            "Confirm",
            "Please make sure all the details are accurate, you will not be able to edit once submitted. Do you want to proceed?",
            [
                { title: "Yes", className: "bg-app text-white mr-l", onClick: () => save(false) },
                { title: "No", className: "bg-app text-white" }
            ]
        );
    }

    const save = (isDraft) => {
        if (isInvalidITDeclaration()) {
            forceUpdate();
            return;
        }

        const payload = getPayload();

        const params = {
            stage: INVESTMENT_STATUS.APPROVED,
            status: isDraft ? INVESTMENT_STATUS.DRAFT : INVESTMENT_STATUS.SUBMITTED,
            financialYearStartDate: moment(getFinancialYearStartDate()).format(DATE_FORMAT.YYYYMMDD)
        };

        const message = (isEdit ? "Updating" : "Saving") + "... Please wait"
        showLoader(message);
        if (!isEdit) {
            INComplianceService.saveITDeclaration(payload, params).then(
                (response) => {
                    removeLoader();
                    if (response) {
                        if (response.status === INVESTMENT_STATUS.SUBMITTED) {
                            setIsLockedState(true);
                        }
                        setIsEdit(true);

                        if (isDraft) {
                            showToast("IT Declaration saved as a draft.", TOAST_TYPE.SUCCESS);
                        } else {
                            showToast("IT Declaration saved successfully.", TOAST_TYPE.SUCCESS);
                        }
                    }
                }, (error) => {
                    removeLoader();
                }
            );
        } else {
            INComplianceService.updateITDeclaration(payload, params).then(
                (response) => {
                    removeLoader();
                    if (response) {
                        if (response.status === INVESTMENT_STATUS.SUBMITTED) {
                            setIsLockedState(true);
                        }

                        if (isDraft) {
                            showToast("IT Declaration updated as a draft.", TOAST_TYPE.SUCCESS);
                        } else {
                            showToast("IT Declaration updated successfully.", TOAST_TYPE.SUCCESS);
                        }
                    }
                }, (error) => {
                    removeLoader();
                }
            );
        }
    }

    const isRequired = (validation) => {
        return validation.findIndex((v) => v[0] === "required") !== -1;
    }

    const getTimePeriod = (value, type) => {
        if (type === INPUT_TYPE.DATE) {
            return value ? `${Utility.formatDate(moment(value).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)}` : '';
        }
        return value

    }

    const getSetState = (section) => {
        let setState;
        switch (section) {
            case SECTION.FINANCIAL_YEAR:
                setState = setFinancialYear;
                break;
            case SECTION.REGIME:
                setState = setNewRegime;
                break;
            case SECTION.HOUSE_RENT:
                setState = setHouseRentState;
                break;
            case SECTION.HOME_LOAN:
                setState = setHomeLoanState;
                break;
            case SECTION.RENTAL_INCOME:
                setState = setRentalIncomeState;
                break;
            case SECTION.INVESTMENT_80C:
                setState = setInvestment80CState;
                break;
            case SECTION.INVESTMENT_80D:
                setState = setInvestment80DState;
                break;
            case SECTION.OTHER_INVESTMENT:
                setState = setOtherInvestmentState;
                break;
            case SECTION.OTHER_INCOME:
                setState = setOtherIncomeState;
                break;
        }
        return setState
    }

    const getValueFromOption = (state, property) => {
        let a = state[property].options[state[property].value]
        return a
    }

    const getField = (section, state, index, property) => {
        let setState;

        setState = getSetState(section)

        switch (state[property].type) {
            case INPUT_TYPE.TEXT:
            case INPUT_TYPE.DATE:
                return (
                    <div className="mb-l">
                        <DKLabel text={state[property].name} className="fs-m fw-m align-self-center width-80" />
                        <DKLabel text={getTimePeriod(state[property].value, state[property].type)} className="fs-m align-self-center width-80" />

                    </div>
                );
            case INPUT_TYPE.NUMBER:
                    return (
                        <div className="mb-l">
                            <DKLabel text={state[property].name} className="fs-m fw-m align-self-center width-80" />
                            <DKLabel text={FormatCurrencyService.format(state[property].value)} className="fs-m align-self-center width-80" />
                        </div>
                    );
            case INPUT_TYPE.SELECT:
                return (
                    <div className="mb-l">
                        <DKLabel text={state[property].name} className="fs-m fw-m align-self-center width-80" />
                        <DKLabel text={getValueFromOption(state, property)} />
                    </div>
                )
            case INPUT_TYPE.CHECKBOX:
                return (
                    <div className="row mb-l" style={{ pointerEvents: state[property].readOnly || isLocked ? "none" : "initial" }}>
                        <DKCheckMark
                            className="pt-s pb-l pointer-events-none"
                            isSelected={state[property].value}
                            readOnly={true}
                            onClick={() => {
                                updateState(section, setState, state, index, property, !state[property].value);
                            }}
                        />
                        <DKLabel className="pt-s pb-l" text={state[property].name} />
                    </div>
                )
            case "radio":
                return (
                    <div className="row mb-l" style={{ pointerEvents: state[property].readOnly || isLocked ? "none" : "initial" }}>
                        {state[property].options.map((o) => {
                            return (
                                <div key={o.value} className="row" style={{ width: "auto" }}>
                                    <input
                                        type="radio"
                                        name={property}
                                        disabled={true}
                                        style={{ margin: "0", marginRight: "5px" }}
                                        value={o.value}
                                        checked={o.value === state[property].value}
                                        onChange={() => {
                                            updateState(section, setState, state, index, property, o.value);
                                        }}
                                    />
                                    <DKLabel className="mr-l" text={o.name} />
                                </div>
                            )
                        })}
                    </div>
                )
        }
    }

    const onRejectClose = () => {
        setRejected({ ...rejected, isReject: false })
    }

    const onRejectSubmit = (comment) => {
        let commentKey = "comment"
        let status = "status"
        let index = rejectField.index
        if (rejectField.section == SECTION.HOME_LOAN || rejectField.section == SECTION.RENTAL_INCOME) {
            switch (rejectField.section) {
                case SECTION.HOME_LOAN:
                    if (rejectField.keyIndex == 1) {
                        commentKey = "interestComment"
                        status = "interestStatus"
                    }
                    break
                case SECTION.RENTAL_INCOME:
                    if (rejectField.keyIndex == 1) {
                        commentKey = "muncipalcomment"
                        status = "muncipalstatus"
                    } else if (rejectField.keyIndex == 2) {
                        commentKey = "princicomment"
                        status = "princistatus"
                    } else if (rejectField.keyIndex == 3) {
                        commentKey = "interestcomment"
                        status = "intereststatus"
                    }
                    break
            }
        }
        let setState = getSetState(rejectField.section)
        const comments = rejectField.state[commentKey].value ? [...rejectField.state[commentKey].value, comment] : [comment];
        updateState(rejectField.section, setState, rejectField.state, rejectField.index, commentKey, comments);
        updateState(rejectField.section, setState, rejectField.state, rejectField.index, status, INVESTMENT_STATUS.REJECTED)
        onRejectClose()
    }

    const onReject = (index, section, state, amountIndex) => {
        let rejectPopupParam = rejectInitial
        rejectPopupParam.isReject = true
        switch (section) {
            case SECTION.HOUSE_RENT:
                rejectPopupParam.name = "House Rent Details"
                rejectPopupParam.amount = ITDeclarationData.houseRents[index].amountDetails[0].declaredAmount
                rejectPopupParam.attachments = ITDeclarationData.houseRents[index].amountDetails[0].attachments

                break
            case SECTION.HOME_LOAN:
                rejectPopupParam.name = "Home Loan Repayment Details"
                rejectPopupParam.amount = ITDeclarationData.homeLoanRepayment[index].amountDetails[amountIndex].declaredAmount
                rejectPopupParam.attachments = ITDeclarationData.homeLoanRepayment[index].amountDetails[amountIndex].attachments

                break
            case SECTION.RENTAL_INCOME:
                rejectPopupParam.name = "Rental Income Details"
                rejectPopupParam.amount = ITDeclarationData.rentalIncome[index].amountDetails[amountIndex].declaredAmount
                rejectPopupParam.attachments = ITDeclarationData.rentalIncome[index].amountDetails[amountIndex].attachments
                break
            case SECTION.INVESTMENT_80C:
                rejectPopupParam.name = "80C Investments"
                rejectPopupParam.amount = ITDeclarationData.investment80C.amountDetails[index].declaredAmount
                rejectPopupParam.attachments = ITDeclarationData.investment80C.amountDetails[index].attachments
                break
            case SECTION.INVESTMENT_80D:
                rejectPopupParam.name = "80D Investments"
                rejectPopupParam.amount = ITDeclarationData.investment80D.amountDetails[index].declaredAmount
                rejectPopupParam.attachments = ITDeclarationData.investment80D.amountDetails[index].attachments
                break
            case SECTION.OTHER_INVESTMENT:
                rejectPopupParam.name = "Other Investments  & Exemption"
                rejectPopupParam.amount = ITDeclarationData.otherExemptions.amountDetails[index].declaredAmount
                rejectPopupParam.attachments = ITDeclarationData.otherExemptions.amountDetails[index].attachments
                break
            case SECTION.OTHER_INCOME:
                rejectPopupParam.name = "Other Source of Income"
                rejectPopupParam.amount = ITDeclarationData.otherIncomeSources.amountDetails[index].declaredAmount
                rejectPopupParam.attachments = ITDeclarationData.otherIncomeSources.amountDetails[index].attachments
                break
        }

        setrejectField({
            index: index,
            state: state,
            section: section,
            keyIndex: amountIndex
        })

        setRejected(rejectPopupParam)
    }

    const checkfieldReadOnly = (state, property) => {
        if (!property) {
            property = "status"
        }
        return state[property].value === INVESTMENT_STATUS.PENDING ? false : true
    }

    const getInputFieldWithlabel = (existingField, name, value, section, index, state, property, status) => {
        let setState = getSetState(section)
        return (
            <div>
                <div>
                    <div style={{ marginBottom: "2px", width: "187px" }}><DKLabel text={name} className="fs-m fw-m align-self-center width-80" /></div>
                    <DKInput
                        type="number"
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        value={state[property].value}
                        errorMessage={state[property].errorMsg}
                        readOnly={checkfieldReadOnly(state, status) || (approvedState && approvedState.status === INVESTMENT_STATUS.SUBMITTED)}
                        required={isRequired(state[property].validation)}
                        invalid={state[property].invalid}
                        canValidate={state[property].invalid}
                        onChange={(value) => {
                            updateState(section, setState, state, index, property, value, existingField);
                        }}
                    />
                    {state[property].invalid &&
                    <div>
                        <DKLabel
                            className=" pt-s fs-s unselectable text-red"
                            style={{
                                whiteSpace: "nowrap",
                            }}
                            text={
                                "Approved amount should be equal or"
                                //   getCapitalized(this.props.title)
                                //   (this.state.required === true ? " *" : "")
                            }
                        />
                        <DKLabel
                            className=" pt-s fs-s unselectable text-red"
                            style={{
                                whiteSpace: "nowrap",
                            }}
                            text={
                                "less than actual amount"
                                //   getCapitalized(this.props.title)
                                //   (this.state.required === true ? " *" : "")
                            }
                        />

                        </div> }
                </div >
            </div>
        )
    }

    const onApproved = (index, section, state, property) => {
        if (!property) {
            property = "status"
        }
        let setState = getSetState(section)
        updateState(section, setState, state, index, property, INVESTMENT_STATUS.APPROVED)

    }

    const getApproveReject = (setState, index, section, state, property, keyIndex) => {
        let statusValue = property ? state[property].value : state.status.value
        return (
            <div>
                { statusValue === INVESTMENT_STATUS.PENDING && <div>
                    <DKIcon
                        className="ic-s-2 cursor-hand"
                        src={ic_check_mark}
                        style={{
                            paddingTop: "27px",
                            paddingLeft: "19px",
                            pointerEvents: `${isLocked || (approvedState && approvedState.status === INVESTMENT_STATUS.SUBMITTED) ? "none": "initial"}`,
                            opacity: `${isLocked || (approvedState && approvedState.status === INVESTMENT_STATUS.SUBMITTED) ? "0.75" : "1"}`
                        }}
                        onClick={() => {
                            onApproved(index, section, state, property);

                        }}
                    />
                    <DKIcon
                        className="ic-s-2 cursor-hand"
                        src={ic_close}
                        style={{
                            paddingTop: "27px",
                            paddingLeft: "15px",
                            pointerEvents: `${isLocked || (approvedState && approvedState.status === INVESTMENT_STATUS.SUBMITTED) ? "none": "initial"}`,
                            opacity: `${isLocked || (approvedState && approvedState.status === INVESTMENT_STATUS.SUBMITTED) ? "0.75" : "1"}`
                        }}
                        onClick={(data) => {
                            onReject(index, section, state, keyIndex);

                        }}
                    />
                </div>}

                {statusValue === INVESTMENT_STATUS.REJECTED &&
                    <div>
                        <div className="row fs-m  pt-xs pb-xs pl-s pr-s border-radius-l data-grid-badge-color-4 text-red mt-xl ml-l" style={{ width: "auto" }}>
                            <div className=" fs-r text-align-left  display-block " style={{ overflowWrap: "break-word" }}>Rejected</div>
                        </div>

                    </div>}
                {statusValue === INVESTMENT_STATUS.APPROVED && <div className="row fs-m  pt-xs pb-xs pl-s pr-s border-radius-l data-grid-badge-color-6 text-green mt-xl ml-l" style={{ width: "auto" }}>
                    <div className=" fs-r text-align-left  display-block " style={{ overflowWrap: "break-word" }}>Approved</div>
                </div>}
            </div>
        )
    }

    const enrichConfig = (state, property, extraConfig) => {
        state[property] = { ...state[property], ...extraConfig };
        return state;
    }

    const isInvalidState = (state) => {
        let invalid = false;

        if (state) {
            if (Array.isArray(state)) {
                state.forEach((s) => {
                    for (const [key, fieldConfig] of Object.entries(s)) {
                        const error = hasError(fieldConfig.name, fieldConfig.value, fieldConfig.validation, fieldConfig.type, fieldConfig);
                        s[key] = { ...fieldConfig, ...error };
                        if (error.invalid) {
                            invalid = true;
                        }
                    }
                });
            } else {
                for (const [key, fieldConfig] of Object.entries(state)) {
                    const error = hasError(fieldConfig.name, fieldConfig.value, fieldConfig.validation, fieldConfig.type, fieldConfig);
                    state[key] = { ...fieldConfig, ...error };
                    if (error.invalid) {
                        invalid = true;
                    }
                }
            }
        }

        return invalid;
    }

    const updateState = (section, setState, state, index, property, value, existingField) => {
        if (property === "financialYear") {
            setState((prevState) => {
                if (Array.isArray(prevState[property].value) && Array.isArray(value) && prevState[property].value[0] !== value[0]) {
                    const newConfig = {
                        ...state[property],
                        value: value,
                        ...hasError(state[property].name, value, state[property].validation, state[property].type)
                    };

                    return {...state, [property]: newConfig};
                }

                return prevState;
            });
        } else {
            setState((prevState) => {
                let newConfig = {
                    ...state[property],
                    value: value,
                    ...hasError(state[property].name, value, state[property].validation, state[property].type)
                };

                if (typeof value === "string" && !Utility.isEmpty(value.trim())) {
                    newConfig = { ...newConfig, ...getErrorForExceedAmount(existingField, state, value) }
                }

                let newState;

                if (index === -1) {
                    newState = { ...state, [property]: newConfig }
                } else {
                    newState = [...prevState];
                    newState[index] = { ...prevState[index], [property]: newConfig };
                }

                return newState;
            });
        }
    }

    const getErrorForExceedAmount = (existingField, state, value) => {
        if (state[existingField] && state[existingField].value < parseInt(value)) {
            let error = {
                invalid: true,
                // value : 0,
                errorMsg: "Approved amount should not be greater than actual amount"
            };
            return error
        }

    }

    const clearValidation = (state, fields) => {
        if (fields && fields.length > 0) {
            fields.forEach((field) => {
                state[field]["validation"] = [[]];
                state[field]["invalid"] = false;
                state[field]["errorMsg"] = null;
            });
        }
    }

    const parseAmount = (number) => {
        return !isNaN(parseFloat(number)) ? parseFloat(number) : 0;
    }

    const hasError = (fieldName, value, validation, type, fieldConfig) => {
        let error = {
            invalid: false,
            errorMsg: null
        };

        switch (type) {
            case INPUT_TYPE.SELECT:
                if (value && value.length === 0) {
                    value = null;
                }
                break;
        }

        if (validation && validation.length !== 0) {
            validation.forEach((validation) => {
                switch (validation[0]) {
                    case "required":
                        if (value === null || value === undefined || String(value).trim() === "") {
                            error.invalid = true;
                            error.errorMsg = fieldName + " is required";
                        }
                        break;
                    case "pattern":
                        if (value && !new RegExp(validation[1]).test(value)) {
                            error.invalid = true;
                            error.errorMsg = "Invalid " + fieldName;
                        }
                        break;
                    case "max":
                        if (fieldConfig && fieldConfig.invalid) {
                            error.invalid = true;
                            error.errorMsg = "";
                        }
                        break;
                }
            });
        }



        return error;
    }

    const getDisableCSSClass = (initial, isButton) => {
        let CSSClass = initial || "";

        if (isLocked) {
            CSSClass += isButton ? " disable-button" : " disable-section";
        }

        return CSSClass;
    }

    const getFinancialYearAndTaxRegime = () => {
        return (
            <div className={getDisableCSSClass(null, false)}>
                <div style={{ width: "200px" }}>
                    <div className="mb-l">
                        <DKInput
                            title={financialYear.financialYear.name}
                            type={financialYear.financialYear.type}
                            className="pb-xl"
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            dropdownConfig={{
                                allowSearch: financialYear.financialYear.options?.length > 7,
                                data: financialYear.financialYear.options,
                                renderer: (i, item) => item,
                                onSelect: (i, value) => {
                                    updateState(null, setFinancialYear, financialYear, -1, "financialYear", [i]);
                                }
                            }}
                            value={getSelectFieldValue(financialYear.financialYear, financialYear.financialYear.options)}
                            errorMessage={financialYear.financialYear.errorMsg}
                            readOnly={true}
                            required={isRequired(financialYear.financialYear.validation)}
                            invalid={financialYear.financialYear.invalid}
                            canValidate={financialYear.financialYear.invalid}
                            onChange={() => { }}
                        />
                    </div>
                </div>
                <div className="pb-xl">
                    {getField(SECTION.REGIME, newRegime, -1, "newRegime")}
                </div>
            </div>
        );
    }

    const getHouseRentDetails = (section, state, index) => {
        return (
            <div key={index}>
                {index !== 0 && <DKLine className="bg-gray3" />}
                <div className="row mt-l">
                    <div className="row align-items-start" style={{ width: "20%", marginRight: marginRight }}>
                        <div style={{ width: "45%", marginRight: "10%" }}>
                            {getField(section, state, index, "rentalFromDate")}
                        </div>
                        <div style={{ width: "45%" }}>
                            {getField(section, state, index, "rentalToDate")}
                        </div>
                    </div>
                    <div style={{ width: "20%" }}>
                        <div>
                            {getField(section, state, index, "amount")}
                        </div>
                    </div>
                    <div className="ml-xxl" style={{ width: "20%" }}>
                        <div>
                            {getAttachmentField(section, state, index, "attachments")}
                        </div>
                    </div>
                    <div className="row align-items-start" style={{ width: "30%" }}>
                        {getInputFieldWithlabel("amount", "Approved Amount", "", section, index, state, "approvedAmount")}{getApproveReject(setHouseRentState, index, section, state, "status")}
                    </div>
                </div>
                <div className="row">
                    <div style={{ width: "20%", marginRight: marginRight }}>
                        <div>
                            {getField(section, state, index, "addressLine1")}
                        </div>
                    </div>
                    <div style={{ width: "20%" }}>
                        <div>
                            {getField(section, state, index, "addressLine2")}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div style={{ width: "20%", marginRight: marginRight }}>
                        <div>
                            {getField(section, state, index, "zipCode")}
                        </div>
                    </div>
                    <div style={{ width: "20%" }}>
                        <div>
                            {getField(section, state, index, "city")}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div style={{ width: "20%", marginRight: marginRight }}>
                        <div>
                            {getField(section, state, index, "state")}
                        </div>
                    </div>
                    <div style={{ width: "20%" }}>
                        <div>
                            {getField(section, state, index, "country")}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div style={{ width: "20%", marginRight: marginRight }}>
                        <div>
                            {getField(section, state, index, "landlordName")}
                        </div>
                    </div>
                    <div style={{ width: "20%" }}>
                        <div>
                            {getField(section, state, index, "landlordPAN")}
                        </div>
                    </div>
                </div>
                <div className="row">
                    {getField(section, state, index, "isMetroCity")}
                </div>
            </div>
        );
    }

    const getHouseRentDetailsSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"House Rent Details"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    {houseRentState.map((houseRent, index) => getHouseRentDetails(SECTION.HOUSE_RENT, houseRent, index))}
                </div>
            </div>
        );
    }

    const getHomeLoanDetails = (section, state, index) => {
        return (
            <div key={index}>
                {index !== 0 && <DKLine className="bg-gray3" />}
                <div className="row mt-l">
                    <div style={{ width: width }}>
                        <div>
                            {getField(section, state, index, "homeLoanPrincipal")}
                        </div>
                    </div>
                    <div style={{ width: width }}>
                        <div>
                            {getAttachmentField(section, state, index, "attachments")}
                        </div>
                    </div>
                    <div className="row align-items-start" style={{ width: width }}>
                        {getInputFieldWithlabel("homeLoanPrincipal", "Approved Amount", "", section, index, state, "approvedAmount")}{getApproveReject(setHouseRentState, index, section, state, "status", 0)}
                    </div>
                </div>
                <div className="row mt-l">
                    <div style={{ width: width }}>
                        <div>
                            {getField(section, state, index, "homeLoanInterest")}
                        </div>
                    </div>
                    <div style={{ width: width }}>
                        <div>
                            {getAttachmentField(section, state, index, "interestAttachments")}
                        </div>
                    </div>
                    <div className="row" style={{ width: width }}>
                        {getInputFieldWithlabel("homeLoanInterest", "Approved Amount", "", section, index, state, "approvedInterestAmount", "interestStatus")}{getApproveReject(setHouseRentState, index, section, state, "interestStatus", 1)}
                    </div>
                </div>
                <div style={{ width: width }}>
                    <div>
                        {getField(section, state, index, "lenderName")}
                    </div>
                    <div>
                        {getField(section, state, index, "lenderPAN")}
                    </div>
                </div>
            </div>
        );
    }

    const getHomeLoanSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"Home Loan Repayment Details"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    {homeLoanState.map((homeLoan, index) => getHomeLoanDetails(SECTION.HOME_LOAN, homeLoan, index))}
                </div>
            </div>
        )
    }

    const getRentalIncomeDetails = (section, state, index) => {
        return (
            <div key={index}>
                {index !== 0 && <DKLine className="bg-gray3" />}
                <div className="row mt-l">
                    <div style={{ width: width }}>
                        {getField(section, state, index, "annualRentReceived")}
                    </div>
                    <div style={{ width: width }}>
                        <div>
                            {getAttachmentField(section, state, index, "attachments")}
                        </div>
                    </div>
                    <div className="row" style={{ width: width }}>
                        {getInputFieldWithlabel("annualRentReceived", "Approved Amount", "", section, index, state, "approvedAmount")}{getApproveReject(setHouseRentState, index, section, state, "status", 0)}
                    </div>
                </div>
                <div className="row mt-l">
                    <div style={{ width: width }}>
                        {getField(section, state, index, "municipalTaxesPaid")}
                    </div>
                    <div style={{ width: width }}>
                        <div>
                            {getAttachmentField(section, state, index, "municipalTaxesAttachments")}
                        </div>
                    </div>
                    <div className="row" style={{ width: width }}>
                        {getInputFieldWithlabel("municipalTaxesPaid", "Approved Amount", "", section, index, state, "approvedMuncipalAmount", "muncipalstatus")}{getApproveReject(setHouseRentState, index, section, state, "muncipalstatus", 1)}
                    </div>
                </div>

                <div style={{ width: width }}>
                    <div>
                        {getField(section, state, index, "netAnnualValue")}
                    </div>
                    <div>
                        {getField(section, state, index, "standardDeduction")}
                    </div>
                    <div className="row">
                        {getField(section, state, index, "repayingHomeLoan")}
                    </div>
                </div>

                {state.repayingHomeLoan.value &&
                    <div >
                        <div className="row mt-l">
                            <div style={{ width: width }}>
                                {getField(section, state, index, "homeLoanPrincipal")}
                            </div>
                            <div style={{ width: width }}>
                                <div>
                                    {getAttachmentField(section, state, index, "principalAttachments")}
                                </div>
                            </div>
                            <div className="row" style={{ width: width }}>
                                {getInputFieldWithlabel("homeLoanPrincipal", "Approved Amount", "", section, index, state, "approvedPrincipalAmount", "princistatus")}{getApproveReject(setHouseRentState, index, section, state, "princistatus", 2)}
                            </div>
                        </div>
                        <div className="row mt-l">
                            <div style={{ width: width }}>
                                {getField(section, state, index, "homeLoanInterest")}
                            </div>
                            <div style={{ width: width }}>
                                <div>
                                    {getAttachmentField(section, state, index, "interestAttachments")}
                                </div>
                            </div>
                            <div className="row" style={{ width: width }}>
                                {getInputFieldWithlabel("homeLoanInterest", "Approved Amount", "", section, index, state, "approvedInterestAmount", "intereststatus")}{getApproveReject(setHouseRentState, index, section, state, "intereststatus", 3)}
                            </div>
                        </div>
                        <div style={{ width: width }}>
                            <div>
                                {getField(section, state, index, "lenderName")}
                            </div>
                            <div>
                                {getField(section, state, index, "lenderPAN")}
                            </div>
                            <div>
                                {getField(section, state, index, "netIncomeLoss")}
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }

    const getRentalIncomeSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"Rental Income Details"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    {rentalIncomeState.map((rentalIncome, index) => getRentalIncomeDetails(SECTION.RENTAL_INCOME, rentalIncome, index))}
                </div>
            </div>
        );
    }

    const getInvestmentDetails = (section, setState, state, index, options) => {
        return (
            <div key={index}>
                <div className="row mt-l">
                    <div style={{ width: "20%" }}>
                        {getField(section, enrichConfig(state, "investment", { options: options }), index, "investment")}
                    </div>
                    <div className="ml-xxl" style={{ width: "20%" }}>
                        {getField(section, state, index, "amount")}
                    </div>
                    <div style={{ width: "20%" }}>
                        <div>
                            {getAttachmentField(section, state, index, "attachments")}
                        </div>
                    </div>
                    <div className="row" style={{ width: width }}>
                        {getInputFieldWithlabel("amount", "Approved Amount", "", section, index, state, "approvedAmount")}{getApproveReject(setHouseRentState, index, section, state)}
                    </div>
                </div>
            </div>
        );
    }

    const get80CInvestmentSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"80C Investments"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    <div className="row">
                    </div>
                    {investment80CState.map((investment, index) => getInvestmentDetails(SECTION.INVESTMENT_80C, setInvestment80CState, investment, index, investment80CItems))}
                </div>
            </div>
        );
    }

    const get80DInvestmentSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"80D Investments"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    <div className="row">
                    </div>
                    {investment80DState.map((investment, index) => getInvestmentDetails(SECTION.INVESTMENT_80D, setInvestment80DState, investment, index, investment80DItems))}
                </div>
            </div>
        );
    }

    const getOtherInvestmentSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"Other Investments & Exemptions"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    <div className="row">
                    </div>
                    {otherInvestmentState.map((investment, index) => getInvestmentDetails(SECTION.OTHER_INVESTMENT, setOtherInvestmentState, investment, index, otherInvestmentItems))}
                </div>
            </div>
        );
    }


    const getOtherIncomeDetails = (section, state, index) => {
        return (
            <div key={index} className="row mb-m">
                <div style={{ width: width, marginRight: marginRight }}>
                    {getField(section, state, index, "amount")}
                </div>
                <div style={{ width: "20%" }}>
                    <div>
                        {getAttachmentField(section, state, index, "attachments")}
                    </div>
                </div>
                <div className="row" style={{ width: "30%" }}>
                    {getInputFieldWithlabel("amount", "Approved Amount", "", section, index, state, "approvedAmount")}{getApproveReject(setHouseRentState, index, section, state)}
                </div>
            </div>
        )
    }

    const getOtherIncomeSection = () => {
        return (
            ITDeclarationData && <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"Other Sources of Income"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    {otherIncomeState.map((otherIncome, index) => getOtherIncomeDetails(SECTION.OTHER_INCOME, otherIncome, index))}
                </div>
            </div>
        );
    }

    const getAttachmentField = (section, state, index, property) => {

        return (
            <div style={{ height: "50px" }}>
                {state[property].files.length >= 0 && <div style={{ marginBottom: "-11px", width: "187px" }}><DKLabel text={"Attachments"} className="fs-m fw-m align-self-center width-80 pb-l" /></div>}

                <div className="row align-items-start">
                    {state[property].files.map((url, i) => {
                        return (
                            <>
                                {url && <div key={url} className="column align-items-center mr-s">
                                    <ReactTooltip type="dark" place="right" html={true} effect='solid' />
                                    <span data-tip={getFilename(url)}>
                                        <DKIcon
                                            className="ic-s mb-s cursor-hand"
                                            src={ic_document}
                                            onClick={() => {
                                                downloadAttachment(url);
                                            }}
                                        />
                                    </span>
                                </div>}
                            </>
                        )
                    })}
                </div>
            </div>
        )
    }

    const getFilename = (url) => {
        return url.substring(url.indexOf("_") + 1, url.length);
    }

    const downloadAttachment = (url) => {
        showLoader("Downloading files... Please wait");
        AttachmentService.getPresignedURL(url).then(
            (response) => {
                AttachmentService.downloadFile(response).then(
                    (response) => {
                        removeLoader();
                        saveAs(response, getFilename(url));
                    }, (error) => {
                        removeLoader();
                    }
                )
            }, (error) => {
                removeLoader();
            }
        )
    }

    const getActionButtons = () => {
        return (
            <div className="row mt-l">
                {(isMyApproval || PermissionUtils.hasAccess(MODULE.EMPLOYEE_APPROVAL, ACTION.SUBMIT)) &&
                    <DKButton
                        title={"SAVE AND SUBMIT"}
                        className={getDisableCSSClass("bg-app text-white mr-l", true)}
                        onClick={() => {
                            showConfirmDialog();
                        }}
                        style={{
                            pointerEvents: `${isLocked || (approvedState && approvedState.status === INVESTMENT_STATUS.SUBMITTED) ? "none": "initial"}`,
                            opacity: `${isLocked || (approvedState && approvedState.status === INVESTMENT_STATUS.SUBMITTED) ? "0.75" : "1"}`
                        }}
                    />
                }
                {(isMyApproval || PermissionUtils.hasAccess(MODULE.EMPLOYEE_APPROVAL, [ACTION.DRAFT])) &&
                    <DKButton
                        title={"SAVE AS DRAFT"}
                        className={getDisableCSSClass("bg-app text-white mr-l", true)}
                        onClick={() => {
                            save(true);
                        }}
                        style={{
                            pointerEvents: `${isLocked || (approvedState && approvedState.status === INVESTMENT_STATUS.SUBMITTED) ? "none": "initial"}`,
                            opacity: `${isLocked || (approvedState && approvedState.status === INVESTMENT_STATUS.SUBMITTED) ? "0.75" : "1"}`
                        }}
                    />
                }
                <DKButton
                    title={"CANCEL"}
                    className="bg-app text-white"
                    onClick={() => {
                        if (employeeData === "true") {
                            RouteManager.navigateToPage("/investments/employees-approval", `stage=${INVESTMENT_STAGE.APPROVED}`);
                        } else {
                            RouteManager.navigateToPage(PAGE_ROUTES.DASHBOARD);
                        }
                    }}

                />
            </div>
        )
    }

    const getITDeclarationForm = () => {
        return (
            <div className="pb-xl">
                {getFinancialYearAndTaxRegime()}
                {getHouseRentDetailsSection()}
                {getHomeLoanSection()}
                {getRentalIncomeSection()}
                {get80CInvestmentSection()}
                {get80DInvestmentSection()}
                {getOtherInvestmentSection()}
                {getOtherIncomeSection()}
                {getActionButtons()}
                {rejected.isReject && <RejectInvestment
                    title={'Reject Investment'}
                    sectionName={rejected.name}
                    amount={rejected.amount}
                    files={rejected.attachments}
                    onReject={(comment) => {
                        onRejectSubmit(comment)
                    }}
                    onClose={() => { onRejectClose() }}
                    downloadAttachment={(url) => downloadAttachment(url)}
                />}
            </div>
        );
    }

    const getEmployeeNameSection = () => {
        return (
            <div className="row p-v-l">
                <DKLabel className="fs-xl fw-m" text={employeeName} />
            </div>
        )
    }

    return (
        <div className="parent-width">
            {employeeName && getEmployeeNameSection()}
            {getITDeclarationForm()}
        </div>
    );
}

export default MyApproval;
